<script lang="ts">
  import type { JsonLdProps } from './json-ld.types';

  const { data }: JsonLdProps = $props();
</script>

<svelte:head>
  {@html `<script type="application/ld+json">${JSON.stringify(data)}</script>`}
</svelte:head>
